<template>
  <v-container class="pa-0 height-score-container" :style="getHeightMainContainer">
    <!-- Loading mask -->
    <HLLoadingMask  v-if="isLoading && enabled"/>
    <!-- List-->
    <v-container class="pa-0" style="height: 100%;" v-else>
      <!-- No highscore -->
      <EspError v-if="!enabled ||highscoreDisabled || apiError" icon="mdi-format-list-numbered">
        {{ $t('statisticNoHighScore', { name: this.labelHighscore }) }}
      </EspError>
      <!-- Highscore list -->
      <v-container class="pa-0" style="height: 100%;" v-else>
        <template v-if="this.coopMode">
            <v-row v-if="this.coopMaxPoints!=0" class="m-0" :style="this.coopPointsSectionHeight"> 
              <PieChart :maxValue="coopMaxPoints" :totalValue="coopTotalPoints"></PieChart>
            </v-row>
            <v-row class="m-0" :style="this.coopPointsSectionHeight">
              <v-col class="vertical-center text-center">
                <div :style="{'color':theme.textColor}">
                  <h1 v-if="this.coopMaxPoints!=0">{{ internalCoopTotalPoints }} of {{ coopMaxPoints }}</h1>
                  <h1 v-else>{{ internalCoopTotalPoints }}</h1>
                  <br/>
                  <h2>{{(labelPoints)?labelPoints:$t('taskPoints')}}</h2>
                </div>
              </v-col>
            </v-row>
        </template>
        <v-row v-else-if="!this.coopMode" style="margin:0;">
          <v-col style="padding:0;">
            <v-simple-table 
                fixed-header
                height="auto"               
              >
                <template v-slot:default>
                  <!-- here to update -->
                  <thead>
                    <tr class="grey">
                      <th class="text-subtitle-2 font-weight-bold text-left grey lighten-3" :class="isSmAndUpDevice?'pl-7':'pr-0'" v-bind:style="{'background-color':theme.headerFooterColor + '!important', 'color':theme.footerIconColor}">
                        <span :style="whiteLabelFontStyle">{{$t('statsRank')}}</span>
                      </th>
                      <th class="text-subtitle-2 font-weight-bold text-left grey lighten-3" v-bind:style="{'background-color':theme.headerFooterColor + '!important', 'color':theme.footerIconColor}">
                      <span :style="whiteLabelFontStyle">{{$t('statsTeam')}}</span>
                      </th>
                      <th :class="isSmAndUpDevice?'pr-6':'pr-2'" class="text-subtitle-2 font-weight-bold text-right grey lighten-3" v-bind:style="{'background-color':theme.headerFooterColor + '!important', 'color':theme.footerIconColor}">
                        {{(labelPoints)?labelPoints:$t('taskPoints')}}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in sortedHighscoreData"
                      :key="item.id"
                      v-bind:style="{'background-color':theme.backgroundColor}"
                    >
                    
                      <td><div :class="isSmAndUpDevice?'pl-5':'pl-1'" class="text-h6 font-weight-medium grey--text text--darken-3" v-bind:style="{'color':theme.textColor + '!important'}">{{ item.platz }}</div></td>
                      <td :class="isSmAndUpDevice?'text-subtitle-1':'text-subtitle-2 pr-0'"><span class="font-weight-bold black--text" v-bind:style="{'color':theme.textColor + '!important'}">
                        <EspAvatar 
                          :size="(isSmAndUpDevice)?80:60" 
                          :color="(item.thumb)?'white':'#cccccc'"
                          :src="(item.thumb)?`${baseUrl}${(isSmAndUpDevice)?item.path:item.thumb}`:null"
                          :alt="item.name"
                          avatarclass="mr-1 mr-sm-8 mt-1 mb-1"
                        />
                          {{ item.name }}
                        </span></td>
                      <td :class="isSmAndUpDevice?'pr-5':'pr-2 pl-0'">
                        <v-row no-gutters justify="end" class="">
                          <v-col cols="auto" align="end" style="text-align: end;" class="text-h6 font-weight-medium grey--text text--darken-3 pr-sm-1"  v-bind:style="{'color':theme.textColor + '!important'}">{{ item.punkte }}</v-col>
                          <v-col v-show="!isXsDevice" cols="5" align="end" style="text-align: end;">
                            <v-icon large :color="theme.textColor">mdi-star-circle</v-icon>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
  import Api from '@/api/event'
  import {eventMixin} from "../../utils/event-mixin";
  import {layoutMixin} from "../../utils/layout-mixin";
  import {imageMixin} from "../../utils/image-mixin";
  import PieChart from './PieChart.vue'
  import HLLoadingMask from "./HLLoadingMask.vue";
  import EspError from "../animation/EspError.vue";
  import EspAvatar from "./EspAvatar.vue";

  export default {
    mixins:[layoutMixin,imageMixin,eventMixin],
    components:{
      HLLoadingMask,
      EspError,
      EspAvatar,
      PieChart
    },
    props:{
      eventId:{
      },
      height:{
        type:String,
        default:null
      },
      enabled:{
        type:Boolean,
        default:true
      },
      labelPoints:{
        type:String,
        default:null
      },
    },
    data: () => ({
      isLoading:false,
      apiError:false,
      selectedEventIdInList:null,
      highscoreData:[],
      highscoreDisabled:false,
      personalData:{},
      baseUrl:"",
      initialTimestamp:new Date().getTime(),
      coopMode:false,//if set to true -> display the team view
      coopMaxPoints:0,
      coopTotalPoints:0,
    }),
    watch:{
  /* Init data on creation and on update */
      eventId: {
        handler(val) {
          this.getHighscore(val);
        },
        immediate: true
      }
    },
    computed:{
      /**
       * To not go over 100%
       */
       internalCoopTotalPoints() {        
            if (this.coopMaxPoints == 0) {
                return this.coopTotalPoints;
            } else {
                return this.coopTotalPoints > this.coopMaxPoints ? this.coopMaxPoints : this.coopTotalPoints;
            }
        },
      /**
       * Height of the section
       */
      coopPointsSectionHeight(){
        return this.coopMode && this.coopMaxPoints != 0 ? 'height: 50%' : 'height: 100%';
      },
      sortedHighscoreData(){
        return this._.orderBy(this.highscoreData,['platz'],['asc']);
      },
      getHeightMainContainer(){
        return this.coopMode ? "height: 100%" : "height: auto";
      }
    },
    methods:{
      refresh(){
        this.getHighscore(this.eventId);
      },
      onChange(){
      },
      getHighscore(event_id){
          this.apiError=false;
          this.isLoading=true;
          Api.getHighscoreByEventId(event_id).then((response)=>{
            if(response && response.data){
              this.baseUrl=this.imageBaseUrl+response.data.baseUrl;
              this.highscoreDisabled=!response.data.enabled;
              this.highscoreData=response.data.teams;
              this.personalData=response.data.you;
              this.coopMode = response.data.coop_mode;
              this.coopMaxPoints = parseInt(response.data.coop_max_points);
              this.coopTotalPoints = parseInt(response.data.coop_total_points);
            }else{
              this.apiError=true;
            }
          }).catch((ex) => {
            console.log(ex);
            this.apiError=true;
          }).finally(()=>{
            this.isLoading=false;
          });
      }
    }
  }
</script>
<style scoped lang="scss">
  div.height-score-container{
    // background-color: rgb(109, 111, 111);
  .vertical-center {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    // color:#fff;
  } 
}
.highscoreTable > .v-data-table__wrapper > table > tbody > tr > td{
  height:100px;
}
</style>